<script>

  import LightBox from 'vue-image-lightbox'
  import Vue from 'vue'

  export default {
    extends: LightBox,
    mounted ()
    {

    },
    watch:   {

      select (val)
      {
        this.$emit('image-changed', val)
      }

    },
    methods: {
      closeLightBox() {

      },
      another: function () {
        this.name = 'another'
      }
    }
  }


</script>